import IconLink from './IconLink';


export default IconLink;
